import { render, staticRenderFns } from "./AppTagsView.vue?vue&type=template&id=222307f7&scoped=true"
import script from "./AppTagsView.vue?vue&type=script&lang=js"
export * from "./AppTagsView.vue?vue&type=script&lang=js"
import style0 from "./AppTagsView.vue?vue&type=style&index=0&id=222307f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222307f7",
  null
  
)

export default component.exports